import React from 'react'

/**
 * A panel component that is used to display content in a card-like format.
 * It has a shadow and rounded corners.
 */
export const SpecialPanel: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
  return (
    <div
      className={`w-unset mx-auto mt-20 flex flex-col items-start gap-2 rounded-md p-8 shadow-none sm:w-[395px] sm:shadow-special ${className}`}
    >
      {children}
    </div>
  )
}

export const SpecialWidrestPanel: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  return (
    <div
      className={`mx-auto mt-[5rem] flex w-[800px] flex-col items-start rounded-tl-[6px] rounded-tr-[6px] p-[2rem] shadow-special ${className}`}
    >
      {children}
    </div>
  )
}

export const SpecialExtraWidrestPanel: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  return (
    <div
      className={`mx-auto mt-[5rem] flex w-[1000px] flex-col items-start rounded-tl-[6px] rounded-tr-[6px] p-[2rem] shadow-special ${className}`}
    >
      {children}
    </div>
  )
}
